import { useSelector } from 'model/hooks'
import Loading from 'components/Loading'
import { useNavigate, useParams } from 'react-router-dom'
import NotFound from 'shared/components/NotFound'
import get from 'lodash/get'
import compact from 'lodash/compact'
import { useContext } from 'react'
import MainContext from 'contexts/MainContext'
import { IEntityType, IItemInfo } from 'shared/types'
import { storageRef } from 'controllers/db'
import CoursePage from 'shared/pages/CoursePage'

const Seminar = () => {
  const { seminarId } = useParams()
  const { openPayment } = useContext(MainContext)
  const seminars = useSelector(state => state.seminars)
  const partitions = useSelector(state => state.partitions)
  const levels = useSelector(state => state.levels)
  const seminar = useSelector(
    state => state.seminars && seminarId && state.seminars[seminarId]
  )
  const userCourses = useSelector(state =>
    get(state.userEntities, 'seminars', {})
  )
  const teachers = useSelector(state => state.teachers)
  const navigate = useNavigate()

  const onPay = () => {
    if (seminar) {
      const itemInfo: IItemInfo = {
        title: seminar.title,
        id: seminar.id,
        type: IEntityType.SEMINARS,
        price: seminar.price,
        paymentLink: seminar.paymentLink
      }
      openPayment(itemInfo)
    }
  }

  if (seminars === null) {
    return <Loading />
  } else if (!seminar) {
    return <NotFound message='Такой семинар не существует' />
  } else {
    const tags = [
      seminar.partitionId
        ? get(partitions, [seminar.partitionId, 'name'])
        : undefined,
      seminar.levelId ? get(levels, [seminar.levelId, 'name']) : undefined,
      ...(seminar.tags || [])
    ]
    return (
      <CoursePage
        course={{ ...seminar, tags: compact(tags) }}
        onPay={onPay}
        toCourse={() => navigate(`/profile/seminars/${seminar.id}`)}
        userCourses={userCourses}
        storageRef={storageRef}
        teachers={teachers || {}}
        partitions={partitions}
      />
    )
  }
}

export default Seminar
